import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=718d1bbd&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('718d1bbd')) {
      api.createRecord('718d1bbd', component.options)
    } else {
      api.reload('718d1bbd', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=718d1bbd&", function () {
      api.rerender('718d1bbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bCfFEmy1nm6w/JS/comp/IncreaseNumber.vue"
export default component.exports